import React from 'react'
import { Link } from 'gatsby'

import { fromProductSlugToUrl } from '../../helpers/products'

export default function ProductColour( props ) {

	const { product, disableText } = props
	let colourVariations = []

	const sortColours = () => {
		const currentProductHex = product.colour_option.hexValue

		// If current product has a colour value, push to colour variations array
		if ( currentProductHex ) {
			const currentProduct = { 
				id: product.id,
				colourHexValue: currentProductHex,
				slug: product.slug
			}

			colourVariations.push( currentProduct )
		}

		// If there are no related products, just render the one colour
		if ( !product.relatedProducts ) { return renderColours() }

		product.relatedProducts.products.forEach( product => {
			const productExists = colourVariations.find( element => element.id === product.id )

			// If the product doesn't exist in the array, push to the colour variations array
			if ( !productExists && product.colour_option.hexValue ) {
				const productToAdd = {
					id: product.id,
					colourHexValue: product.colour_option.hexValue,
					slug: product.slug
				}
				colourVariations.push( productToAdd )
			}
		})

		// Sort into ID order so they are in the same order for each related product
		colourVariations.sort( (a, b) => {
			return a.id - b.id
		} )

		return renderColours()
	}

	const renderColours = () => {

		return (
			colourVariations.map( colour => (
				<React.Fragment key={ colour.id }>
					{ colour.id === product.id ? (
						<li className="product-colour__item product-colour__item--active">
							<div className="product-colour__colour" style={{ backgroundColor: `#${colour.colourHexValue}` }}></div>
						</li>
					) : (
						<li className="product-colour__item">
							<Link to={ fromProductSlugToUrl( colour.slug ) } className="product-colour__colour"  style={{ backgroundColor: `#${colour.colourHexValue}` }} />
						</li>
					) }
				</React.Fragment>
			) )
		)
	}

	return (
		<div className={`product-colour ${ disableText ? 'product-colour--grid' : '' }`}>
			<ul className="product-colour__list">
				{ sortColours() }
				{ !disableText &&
					<li className="product-colour__label">
						{ product.colour_option.name }
					</li>
				}
			</ul>
		</div>
	)
}